import { getData } from "../../api/api";
import {
  REQUEST_MESSAGES_PENDING,
  REQUEST_MESSAGES_SUCCESS,
  REQUEST_MESSAGES_FAILED,
  RECEIVE_MESSAGE,
} from "./actionTypes";

import { GetMessageUrl } from "../../config";

export const requestMessages =
  (roomId = "") =>
  (dispatch) => {
    const baseUrl = GetMessageUrl() + "/api/message";
    const url = roomId ? `${baseUrl}/${roomId}` : baseUrl;
    dispatch({ type: REQUEST_MESSAGES_PENDING });
    getData(url)
      .then((data) => dispatch({ type: REQUEST_MESSAGES_SUCCESS, payload: data }))
      .catch((error) => dispatch({ type: REQUEST_MESSAGES_FAILED, payload: error }));
  };

export function receiveMessage(
  userName = "",
  message = "",
  roomId = null,
  id = null,
  postedAt = null,
  fromApotheek = null,
  currentRoomId = null
) {
  return {
    type: RECEIVE_MESSAGE,
    payload: {
      message: {
        userName,
        id,
        roomId,
        postedAt,
        contents: message,
        fromApotheek,
      },
      currentRoomId,
    },
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/messageActions.js